module.exports = __webpack_public_path__ + "static/media/video2.c740216c.mp4";